<template>
  <artisio-modal
      :visible="showModal"
      :title="computedTitle"
      @hidden="onHidden"
      size="l"
      @ok="onSubmit"
      :disable-submit-btn="submitDisabled"
  >
    <div class="row" v-if="lot">
      <div class="col-md-6">
        <input-widget :model="lot" attribute="proposal_suggestion" type="select2" value-field="value"
                      display-field="${item.key}" :items="suggestionOptions"
                      @select2Select="onProposalSuggestionSelect" aria-required="true" :rules="{required: !!lot.proposal_status}" />
      </div>
      <div class="col-md-6">
        <input-widget :model="lot" attribute="proposal_status" type="select2"
                      value-field="value" display-field="${item.key}"
                      :items="proposalStatusOptions"/>
      </div>
      <div class="col-md-6">
        <currency-input-widget :model="lot" attribute="new_reserve" type="number" :disabled="newValuesDisabled"
                               :append-question="getAmountFieldQuestionText('reserve')"
                               :currency="currencySymbol"/>
      </div>
      <div class="col-md-6">
        <currency-input-widget :model="lot" attribute="new_low" type="number" :disabled="newValuesDisabled"
                               :append-question="getAmountFieldQuestionText('low')"
                               :currency="currencySymbol"/>
      </div>
      <div class="col-md-6">
        <currency-input-widget :model="lot" attribute="new_high" type="number" :disabled="newValuesDisabled"
                               :append-question="getAmountFieldQuestionText('high')"
                               :currency="currencySymbol"/>
      </div>
      <div class="col-md-6">
        <currency-input-widget :model="lot" attribute="new_start_price" type="number" :disabled="newValuesDisabled"
                               :append-question="getAmountFieldQuestionText('start_price')"
                               :currency="currencySymbol"/>
      </div>
      <div class="col-md-6">
        <input-widget
          :model="lot"
          attribute="new_reserve_type"
          type="select2"
          value-field="value"
          display-field="${item.key}"
          :items="reserveTypes"
          :disabled="newValuesDisabled"
        />
      </div>
      <div class="col-md-6">
        <input-widget :model="lot" attribute="proposal_comment" type="text" />
      </div>
    </div>
  </artisio-modal>
</template>


<script>
import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal.vue";
import {createNamespacedHelpers} from "vuex";
import InputWidget from "@/core/components/input-widget/InputWidget.vue";
import {LotProposalEditModel} from "@/modules/vendors/LotProposalEdit.model";
import CurrencyInputWidget from "@/core/widgets/CurrencyInputWidget.vue";
import {ON_UNSOLD_LOT_PROPOSAL_INPUT} from "@/plugins/event-bus/event-bus-names";

const {mapState, mapActions} = createNamespacedHelpers('vendors/unsoldProposals');
const {mapState: mapStateGlobal} = createNamespacedHelpers('global');
export default {
  name: "LotProposalEditModal",
  components: {CurrencyInputWidget, InputWidget, ArtisioModal},
  computed: {
    ...mapStateGlobal({
      enableInventoryQuantity: state => state.enableInventoryQuantity,
      reserveTypes: state => state.reserveTypes,
    }),
    ...mapState({
      showModal: state => state.lotEditModal.show,
      lot: state => state.lotEditModal.lot,
      reservation_uuid: state => state.lotEditModal.reservation_uuid,
      lot_no: state => state.lotEditModal.lot_no,
      suggestionOptions: state => state.suggestionOptions,
      proposalStatusOptions: state => state.proposalStatusOptions,
      auction: state => state.unsoldProposalModal.auction
    }),
    computedTitle() {
      if (!this.lot) return ''
      return this.$i18n.t(`Edit lot ${this.lot_no}`)
    },
    newValuesDisabled() {
      return this.lot.proposal_suggestion !== 'reoffer'
    },
    currencySymbol() {
      if (!this.auction) return ''
      return this.auction.currency.symbol;
    },
    submitDisabled() {
      if (!this.lot) return false
      return !!this.lot.proposal_status && !this.lot.proposal_suggestion;
    },
  },
  methods: {
    ...mapActions(['hideLotEditModal', 'updateLotEditModal']),
    onHidden() {
      this.hideLotEditModal()
    },
    onSubmit() {
      if (this.lot.new_low && this.lot.new_high && parseFloat(this.lot.new_low) > parseFloat(this.lot.new_high)) {
        this.$errorDialog(this.$i18n.t('New Low Estimate value must be less than New High Estimate value.'))
        return
      }
      this.$evBus.$emit(ON_UNSOLD_LOT_PROPOSAL_INPUT, {[this.reservation_uuid]: this.lot})
      this.hideLotEditModal()
    },
    getAmountFieldQuestionText(attribute) {
      if (!this.enableInventoryQuantity) {
        return null;
      }
      let fieldName = this.$options.filters.removeUnderscores(attribute);
      fieldName = this.$options.filters.toUpperCaseFirst(fieldName);
      return this.$i18n.t("{fieldName} amount given for single quantity of the item", {fieldName})
    },
    onProposalSuggestionSelect() {
      this.updateLotEditModal(new LotProposalEditModel({
        ...this.lot,
        proposal_status: 'suggestion_not_sent',
      }))
    },
  },
  watch: {
    'lot.proposal_suggestion'() {
      if (!this.lot) return
      if (this.lot.proposal_suggestion !== 'reoffer') {
        this.updateLotEditModal(new LotProposalEditModel({
          proposal_suggestion: this.lot.proposal_suggestion,
          proposal_status: this.lot.proposal_status,
          proposal_comment: this.lot.proposal_comment,
        }))
      }
    }
  }
}
</script>
